import React from 'react';
import { StyledAppLogo, StyledLogo, StyledLogoSubtitle, StyledLogoSubtitleContainer } from './AppLogo.styled';
import { IMAGES_URL } from '../../constants';

interface IAppLogoProps {
  className?: string
}



export const AppLogo: React.FC<IAppLogoProps> = ({ className }) => {
  const getLogo = () => {
    return (
      <>
        <StyledLogo src={`${IMAGES_URL}logo-white.png`} />
        <StyledLogo src={`${IMAGES_URL}training-ground-logo.png`}/>
      </>
    )
  };

  return <StyledAppLogo className={className}>{getLogo()}</StyledAppLogo>;
}